export default __webpack_public_path__ + "static/media/HallsofEternalFrostMap.2f3ac19c.jpg";